import { ref, watch } from "vue";
import { useCookies } from "@vueuse/integrations/useCookies";

import { trackEvent } from "@/utils/track-event";

import { type ColumnOrderState } from "@tanstack/vue-table";

export const useMemoDefaultColumnOrder = ({
  key,
  state = [],
  trackingEventCategory = key,
}: {
  key: string;
  state?: ColumnOrderState;
  trackingEventCategory?: string;
}) => {
  const cookies = useCookies();
  const columnOrderFromCookies = cookies.get(key);

  const columnOrder = ref<ColumnOrderState>(columnOrderFromCookies ?? state);

  const memoizeColumnSizing = () => {
    cookies.set(key, columnOrder.value);
  };

  const resetColumnSizing = () => {
    columnOrder.value = state;
  };

  watch(
    () => columnOrder.value,
    () => {
      memoizeColumnSizing();

      trackEvent({
        category: trackingEventCategory,
        action: "Column order changed",
        name: JSON.stringify(columnOrder.value),
      });
    },
  );

  return {
    columnOrder,
    resetColumnSizing,
  };
};

export default {};
